// @flow
import React from 'react';

import { StyledLabel } from '../../common-utils/styledComponents';

export const EstimateCommittedCapacityDescriberContainer = () => (
  <StyledLabel size="large">
    Add metrics or components to configure committed capacity quantity. Admins can add, edit and
    delete existing rows. Non-admins can only add new rows and delete existing rows.
  </StyledLabel>
);
